import { useRef, useState } from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import { STRINGS } from '../../constants';
import ConfigSlice from '../../redux/configSlice';
import { HELP_SERVICE_TYPES } from './constants';
import { HelpServiceSelection } from './components/HelpServiceSelection';
import { CitysprintHelpSupport } from './components/CitysprintHelpSupport';
import { DpdOnlineHelpFlow } from './components/DpdOnlineHelpFlow';

const Help = () => {
  const theme = useTheme();
  const { sameday } = useSelector(ConfigSlice.selectors.getFeatureConfig);
  const [selectedService, setSelectedService] = useState(null);
  const chatButtonContainerRef = useRef(null);

  const isDpdOnlineSelected = selectedService === HELP_SERVICE_TYPES.DPD_ONLINE;
  const isSamedaySelected = selectedService === HELP_SERVICE_TYPES.SAMEDAY;

  return (
    <Box
      sx={{
        py: { xs: 2 },
        p: { md: 4 },
        background: theme.vars.palette.primary.backgroundLightGray,
        flexGrow: 1,
      }}
    >
      <Grid
        container
        sx={{
          justifyContent: 'center',
          mt: 1,
        }}
      >
        <Grid>
          <Typography variant='h2' component='h1' sx={{ m: 2, mt: 0 }}>
            {STRINGS.HOW_CAN_WE_HELP}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={0} alignItems='center' justifyContent='center'>
        <Grid
          sx={{ maxWidth: { md: '562px' } }}
          size={{
            xs: 12,
            md: 9,
            lg: 7,
            xl: 6,
          }}
        >
          <HelpServiceSelection
            selectedService={selectedService}
            onSelectService={setSelectedService}
            showSameday={sameday}
          />

          {isSamedaySelected ? <CitysprintHelpSupport /> : null}

          {isDpdOnlineSelected ? (
            <DpdOnlineHelpFlow chatButtonContainer={chatButtonContainerRef} />
          ) : null}
        </Grid>
      </Grid>
      <Box
        sx={{
          position: 'relative',
          pr: 2,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
        ref={chatButtonContainerRef}
      />
    </Box>
  );
};

export default Help;
